/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Types of accommodations:<br />
 * Adult - adult with main occupancy<br />
 * ExtraAdult - adult on extra bed<br />
 * Child - child with main occupancy<br />
 * ExtraChild - child on extra bed<br />
 * ChildBandWithoutBed - child without bed
 * @export
 */
export const TravelinePlacementKindDto = {
    Adult: 'Adult',
    ExtraAdult: 'ExtraAdult',
    Child: 'Child',
    ExtraChild: 'ExtraChild',
    ChildBandWithoutBed: 'ChildBandWithoutBed'
} as const;
export type TravelinePlacementKindDto = typeof TravelinePlacementKindDto[keyof typeof TravelinePlacementKindDto];


export function instanceOfTravelinePlacementKindDto(value: any): boolean {
    for (const key in TravelinePlacementKindDto) {
        if (Object.prototype.hasOwnProperty.call(TravelinePlacementKindDto, key)) {
            if (TravelinePlacementKindDto[key as keyof typeof TravelinePlacementKindDto] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TravelinePlacementKindDtoFromJSON(json: any): TravelinePlacementKindDto {
    return TravelinePlacementKindDtoFromJSONTyped(json, false);
}

export function TravelinePlacementKindDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelinePlacementKindDto {
    return json as TravelinePlacementKindDto;
}

export function TravelinePlacementKindDtoToJSON(value?: TravelinePlacementKindDto | null): any {
    return value as any;
}

export function TravelinePlacementKindDtoToJSONTyped(value: any, ignoreDiscriminator: boolean): TravelinePlacementKindDto {
    return value as TravelinePlacementKindDto;
}

